import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { PrintSO } from "./PrintSO";
import { getActionDoDisplay, isDisabledEditDo } from "utils/HelperDoFunction";
import { PrintDOPickList } from "./PrintDOPickList";
import { PrintDODelivery } from "./PrintDODelivery";
import useDoExport from "hooks/deliveryOrder/useDoExport";
import moment from "moment";
export default function DoFooterSubmit(param) {
    var setFieldValue = param.setFieldValue, setModalNotApprove = param.setModalNotApprove, setModalConfirmCancel = param.setModalConfirmCancel, setModalDeliEndProcess = param.setModalDeliEndProcess, setModalReadyToDeliProcess = param.setModalReadyToDeliProcess, values = param.values, productRow = param.productRow, formdisabled = param.formdisabled, setFormdisabled = param.setFormdisabled, companyInfo = param.companyInfo, options = param.options, setProductRow = param.setProductRow;
    var navigate = useNavigate();
    var componentPickListRef = useRef();
    var componentDeliveryRef = useRef();
    var handlePickListPrint = useReactToPrint({
        content: function() {
            return componentPickListRef.current;
        }
    });
    var handleDeliveryPrint = useReactToPrint({
        content: function() {
            return componentDeliveryRef.current;
        }
    });
    var downloadExcel = useDoExport().downloadExcel;
    return /*#__PURE__*/ _jsx("div", {
        className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow z-[10]",
        style: {
            minWidth: "1000px"
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-body px-xl-3 d-flex justify-between",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-2",
                    children: [
                        /*#__PURE__*/ _jsxs(Dropdown, {
                            children: [
                                /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                    className: "btn btn-st-8 fs-14  px-4",
                                    id: "dropdown-basic",
                                    style: {
                                        backgroundColor: "#2192FF",
                                        borderColor: "#2192FF",
                                        height: "40px"
                                    },
                                    children: "พิมพ์เอกสาร"
                                }),
                                /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                    className: "p-0 border-0 bg-transparent",
                                    children: [
                                        /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    style: {
                                                        display: "none"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(PrintDOPickList, {
                                                            innerRef: componentPickListRef,
                                                            values: values,
                                                            companyInfo: companyInfo
                                                        }),
                                                        /*#__PURE__*/ _jsx(PrintDODelivery, {
                                                            innerRef: componentDeliveryRef,
                                                            values: values,
                                                            companyInfo: companyInfo
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Button, {
                                                    onClick: handlePickListPrint,
                                                    type: "button",
                                                    className: "btn-st-9 fs-14 border-0 px-3 me-3 w-full",
                                                    disabled: !getActionDoDisplay({
                                                        formdisabled: formdisabled,
                                                        dimMstNewStatus: values.dimMstDoStatus
                                                    }).statusReadyPickList,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("i", {
                                                            className: "iprinter"
                                                        }),
                                                        "ใบจัดสินค้า"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Button, {
                                            onClick: handleDeliveryPrint,
                                            type: "button",
                                            className: "btn-st-8 fs-14 border-0 px-3 me-3 w-full",
                                            disabled: !getActionDoDisplay({
                                                formdisabled: formdisabled,
                                                dimMstNewStatus: values.dimMstDoStatus,
                                                values: values
                                            }).statusReadyDelivery,
                                            children: [
                                                /*#__PURE__*/ _jsx("i", {
                                                    className: "iprinter"
                                                }),
                                                "ใบส่งสินค้า"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: function() {
                                return downloadExcel({
                                    datas: productRow,
                                    primaryData: values,
                                    filename: "".concat(values.doc_number, "-").concat(moment().format("YYYY_MM_DD"))
                                });
                            },
                            type: "button",
                            className: "btn-st-8 fs-14 border-0 px-3 me-3 w-full",
                            disabled: !getActionDoDisplay({
                                formdisabled: formdisabled,
                                dimMstNewStatus: values.dimMstDoStatus,
                                values: values
                            }).statusReadyDelivery,
                            children: "Export Excel"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    onClick: function(e) {
                        navigate("/sale/delivery-order");
                    },
                    className: "btn-st-6 me-3 btn ms-auto",
                    children: "ย้อนกลับ"
                }),
                getActionDoDisplay({
                    formdisabled: formdisabled,
                    dimMstNewStatus: values.dimMstDoStatus,
                    values: values
                }).statusCancel && /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    onClick: function(e) {
                        setModalConfirmCancel(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                    },
                    className: "bg-[#FF0000] text-white border-[#FF0000] me-3 px-4 btn ",
                    children: "ยกเลิก"
                }),
                getActionDoDisplay({
                    formdisabled: formdisabled,
                    dimMstNewStatus: values.dimMstDoStatus,
                    values: values
                }).statusBtnPickList && /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    onClick: function(e) {
                        var _options_branch, _options_warehouse;
                        // Auto-set dim_branch_id if empty
                        if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                            setFieldValue("dim_branch_id", 1);
                        }
                        // Auto-set dim_warehouse_id if empty
                        if ((options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) === 1) {
                            setFieldValue("dim_warehouse_id", 1);
                            setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                return prev.map(function(row) {
                                    return _object_spread_props(_object_spread({}, row), {
                                        warehouseID: 1,
                                        warehouseName: options.warehouse[0].label
                                    });
                                });
                            });
                        }
                        setModalReadyToDeliProcess(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                    },
                    className: "btn-st-9 me-3",
                    children: "ยืนยันสินค้าพร้อมจัดส่ง"
                }),
                getActionDoDisplay({
                    formdisabled: formdisabled,
                    dimMstNewStatus: values.dimMstDoStatus
                }).status2 && /*#__PURE__*/ _jsx(ButtonGroup, {
                    className: " btn-group-st-1 ",
                    children: getActionDoDisplay({
                        formdisabled: formdisabled,
                        dimMstNewStatus: values.dimMstDoStatus
                    }).status2_1 && /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        onClick: function() {
                            var _options_branch, _options_warehouse;
                            setFieldValue("dim_mst_do_status_id", 2);
                            // Auto-set dim_branch_id if empty
                            if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                                setFieldValue("dim_branch_id", 1);
                            }
                            // Auto-set dim_warehouse_id if empty
                            if ((options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) === 1) {
                                setFieldValue("dim_warehouse_id", 1);
                                setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                    return prev.map(function(row) {
                                        return _object_spread_props(_object_spread({}, row), {
                                            warehouseID: 1,
                                            warehouseName: options.warehouse[0].label
                                        });
                                    });
                                });
                            }
                        },
                        children: "อนุมัติ"
                    })
                }),
                getActionDoDisplay({
                    formdisabled: formdisabled,
                    dimMstNewStatus: values.dimMstDoStatus,
                    values: values
                }).statusReadyฺBtnDelivery && /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    onClick: function(e) {
                        var _options_branch, _options_warehouse;
                        // Auto-set dim_branch_id if empty
                        if ((options === null || options === void 0 ? void 0 : (_options_branch = options.branch) === null || _options_branch === void 0 ? void 0 : _options_branch.length) === 1) {
                            setFieldValue("dim_branch_id", 1);
                        }
                        // Auto-set dim_warehouse_id if empty
                        if ((options === null || options === void 0 ? void 0 : (_options_warehouse = options.warehouse) === null || _options_warehouse === void 0 ? void 0 : _options_warehouse.length) === 1) {
                            setFieldValue("dim_warehouse_id", 1);
                            setProductRow === null || setProductRow === void 0 ? void 0 : setProductRow(function(prev) {
                                return prev.map(function(row) {
                                    return _object_spread_props(_object_spread({}, row), {
                                        warehouseID: 1,
                                        warehouseName: options.warehouse[0].label
                                    });
                                });
                            });
                        }
                        setModalDeliEndProcess(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                    },
                    className: "btn-st-8 me-3",
                    children: "ยืนยันการจัดส่งสำเร็จ"
                })
            ]
        })
    });
}
